import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/gpts`} />

    <Route
      path={`${match.url}/list`}
      component={asyncComponent(() => import("./routes/list"))}
    />

    <Route
      component={asyncComponent(() =>
        import("app/routes/extraPages/routes/404")
      )}
    />
  </Switch>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/gpts/index.js